import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Product } from '@shared/models/product.model';

export interface DashboardMetrics {
  totalProducts: number;
  newProductsWeek: number;
  activeRules: number;
  priceChangesToday: number;
  avgMargin: number;
  revenue: number;
  profitMargin: number;
}

export interface PriceChangeActivity {
  id: string;
  productId: string;
  productName: string;
  oldPrice: number;
  newPrice: number;
  reason: string;
  timestamp: Date;
}

export interface PriceTrendData {
  date: string;
  averagePrice: number;
  minPrice: number;
  maxPrice: number;
}

export interface MarketplaceData {
  name: string;
  value: number;
  orders: number;
  priceChanges: number;
  avgPrice: number;
}

export interface DashboardData {
  metrics: DashboardMetrics;
  topProducts: Product[];
  recentPriceChanges: PriceChangeActivity[];
  priceTrends?: PriceTrendData[];
  marketplaceData?: MarketplaceData[];
}

export const DashboardActions = createActionGroup({
  source: 'Dashboard',
  events: {
    // Load Dashboard Data
    'Load Dashboard Data': emptyProps(),
    'Load Dashboard Data Success': props<{ data: DashboardData }>(),
    'Load Dashboard Data Failure': props<{ error: string }>(),

    // Refresh Metrics
    'Refresh Metrics': emptyProps(),
    'Refresh Metrics Success': props<{ metrics: DashboardMetrics }>(),
    'Refresh Metrics Failure': props<{ error: string }>(),

    // Load Top Products
    'Load Top Products': emptyProps(),
    'Load Top Products Success': props<{ products: Product[] }>(),
    'Load Top Products Failure': props<{ error: string }>(),

    // Load Recent Price Changes
    'Load Recent Price Changes': emptyProps(),
    'Load Recent Price Changes Success': props<{ changes: PriceChangeActivity[] }>(),
    'Load Recent Price Changes Failure': props<{ error: string }>(),

    // Real-time Updates
    'Price Change Notification': props<{ change: PriceChangeActivity }>(),
    'Metrics Update': props<{ metrics: Partial<DashboardMetrics> }>(),

    // Clear Error
    'Clear Error': emptyProps()
  }
});